export default __webpack_public_path__ + "static/media/liquidity.685f74a4.svg";